module.exports = __webpack_public_path__ + "static/media/pegadaian.27033fd1.png";